import React from 'react'

import { MdOutlineMovie } from 'react-icons/md'
import { MdIncompleteCircle } from 'react-icons/md'

import '../assets/css/card_dynamic.css'
import Renderif from 'utils/renderif'
import { useNavigate } from 'react-router'
import { DDMMYYYY, getStatus } from 'utils/functions'
import { Button } from 'react-bootstrap'

const CardDynamic = ({activity}) => {
  const navigate = useNavigate()
  return (
    <div className="card-container mt-2">

      <div className="card-header">

        <div className='w-100'>
            
              <Renderif isTrue={activity.image !== ""}>
                <img width={'100%'} className='r-10' src={activity.image}></img>
              </Renderif>
          
            <div className="title mt-3">
              <div className='f-18 text-darkblue bold'>{activity.name}</div>
       
              <div className='f-14 text-dark-emphasis mt-3'><span className='bold text-dark-emphasis'>Vencimiento</span>: {DDMMYYYY(activity?.expiration)}</div>
              <div className='d-flex mt-1'>
                <div className='f-14 text-dark-emphasis me-1'><span className='bold text-dark-emphasis'>Estado</span>:</div>
                <div className={`tag tag--${activity?.status === true ? 'green' : 'gray'}`}>{getStatus(activity?.status)}</div>

              </div>

            </div>
        </div>

      </div>


      <div className="card-body d-none">
        <div className="info-row">
          <span>Tiempo promedio del usuario en el juego</span>
          <span>1 min</span>
        </div>
        <div className="progress-bar">
          <div className="progress" style={{ width: '20%' }}></div>
        </div>
        <div className="info-row">
          <span>Total de ganadores</span>
          <span>1/50</span>
        </div>
        <div className="progress-bar">
          <div className="progress" style={{ width: '2%' }}></div>
        </div>
        <div className="info-row">
          <span>Total juego jugado</span>
          <span>6</span>
        </div>
        <div className="progress-bar">
          <div className="progress" style={{ width: '12%' }}></div>
        </div>
      </div>
      <div className="card-footer">
        <Button className='button--pruple' onClick={()=>{
               navigate(`/question/${activity.id}`)
        }}>
          Ver Más
        </Button>
        {/* <button className="btn-ver-mas" onClick={()=>{
          navigate(`/question/${activity.id}`)
        }}>Ver más</button> */}
        {/* <div className="timer">
      
            ⏰
   
          <MdIncompleteCircle />
          &nbsp; 00:09:50
        </div> */}
      </div>
    </div>
  )
}

export default CardDynamic
